var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { useEffect, useMemo, useState } from "react";
import { useBrandUrl } from "@/hooks";
import { useMediumImages } from "@/gallery/hooks";
import { embedBuilders, getPreviewUrl, getProviderName } from "./mediaProviders";
export const useMedia = (media) => {
    var _a, _b;
    const mediumImages = (_b = (_a = useMediumImages()) === null || _a === void 0 ? void 0 : _a[0]) === null || _b === void 0 ? void 0 : _b.url;
    const fallbackPreviewImageUrl = useBrandUrl({
        endpoint: "/shared/images/media/3d-tour-preview-fallback.png",
    });
    const provider = useMemo(() => {
        if (!(media === null || media === void 0 ? void 0 : media.url))
            return null;
        return getProviderName(media.url);
    }, [media]);
    const embedUrl = useMemo(() => {
        if (!(media === null || media === void 0 ? void 0 : media.url) || !provider)
            return null;
        const builder = embedBuilders[provider];
        return builder ? builder(media.url) : null;
    }, [media === null || media === void 0 ? void 0 : media.url, provider]);
    const [previewUrl, setPreviewUrl] = useState(null);
    useEffect(() => {
        let active = true;
        const fetchPreview = () => __awaiter(void 0, void 0, void 0, function* () {
            if (!(media === null || media === void 0 ? void 0 : media.url))
                return;
            const url = provider ? yield getPreviewUrl(media.url, provider) : null;
            if (active) {
                setPreviewUrl(url || mediumImages || fallbackPreviewImageUrl);
            }
        });
        fetchPreview();
        return () => {
            active = false;
        };
    }, [media, provider, mediumImages, fallbackPreviewImageUrl]);
    return {
        embedUrl,
        previewUrl,
        previewFallBackUrl: mediumImages || fallbackPreviewImageUrl,
    };
};
